import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { GetUserSuccessResponseInfoAllOfResult, UserApi } from '../axios/generated/userManage';
import { IError } from '../interfaces/IError';
import { customAxiosInstance } from '../axios/axiosInstance';
import { axiosErrorHandler } from '../axios/axiosError';
import { IUserRepository } from '../interfaces/IUserRepository';

/**
 * ユーザーを永続化するリポジトリ
 * ここでは基本的にRDSのUserInfoTableについての操作を行います
 */
export class UserRepository implements IUserRepository {
  /**
   * 組織内のユーザー一覧を取得する
   * @param keyword - ユーザー名検索キーワード
   */
  async get(keyword?: string): Promise<INetworkResult<GetUserSuccessResponseInfoAllOfResult, IError>> {
    const axiosInstance = await customAxiosInstance('dbAccess');
    const userApi = new UserApi(undefined, undefined, axiosInstance);
    // APIを叩く
    try {
      const apiResponse = await userApi.getUser(keyword);
      switch (apiResponse.status) {
        case 200:
          const result: GetUserSuccessResponseInfoAllOfResult = apiResponse.data.result;
          return { status: { type: 'success', data: result } };
        default:
          throw new Error('想定外のレスポンス');
      }
    } catch (e) {
      return { status: { type: 'error', error: axiosErrorHandler(e) } };
    }
  }
}
